// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__rc2wz","filters_close":"FiltersBlock_filters_close__U2+B-"};